/**
 * Properties for objects, attributes, values
 */
export const PropertyType = {
    ObjectProperties: "objectProperties",
    AttributeProperties: "attributeProperties",
    ValueProperties: "valueProperties",
    Properties: "properties",
};
/**
 * Prefixes for lookup
 */
export const TranslationPrefix = {
    // Configuration: "configuration",
    CfgObjects: "objects",
    Attributes: "attributes",
    AttributeGroups: "attributeGroups",
    Translations: "translations",
    Units: "units",
    Properties: PropertyType.ObjectProperties,
};
function validateConfigurationObject(param) {
    if (param.objectId == null) {
        throw new Error("objectId is null");
    }
}
function validateConfigurationAttribute(param) {
    if (param.attributeId == null) {
        throw new Error("attributeId is null");
    }
}
function validateConfigurationValue(param) {
    var _a;
    if (((_a = param.valueId) !== null && _a !== void 0 ? _a : param.value) == null) {
        throw new Error("value.id and  value.value is null");
    }
}
// objects
export function objectDictId(param) {
    validateConfigurationObject(param);
    return `${TranslationPrefix.CfgObjects}.${param.objectId}`;
}
// attributes
export function attributeDictId(param) {
    validateConfigurationAttribute(param);
    return `${TranslationPrefix.Attributes}.${param.attributeId}`;
}
// values
export function valueDictId(param) {
    var _a;
    validateConfigurationValue(param);
    const valueId = (_a = param.valueId) !== null && _a !== void 0 ? _a : param.value;
    return `${attributeDictId(param)}.values.${valueId}`;
}
// groups
export function groupDictId(attributeGroupId) {
    return `${TranslationPrefix.AttributeGroups}.${attributeGroupId}`;
}
//# sourceMappingURL=translation.helpers.js.map